import { getPath } from '@/router/common'

const baseUrl = {
  title: '系统检测',
  path: 'home'
}
const baseUrlUpper = {
  title: '明细',
  path: 'Home'
}

export default [
  {
    path: getPath('CheckSystem', baseUrl),
    name: 'home_CheckSystem',
    component: () => import(/* webpackChunkName: "home_CheckSystem" */ '@/views/home/checkSystem/index.vue'),
    meta: {
      title: '系统检测'
    }
  },
  {
    path: getPath('indexnewtwo', baseUrl),
    name: 'home_indexnewtwo',
    component: () => import(/* webpackChunkName: "home_indexnewtwo" */ '@/views/home/indexnewtwo/index.vue'),
    meta: {
      title: '我的主页'
    }
  },
  {
    path: getPath('indexnewtwoV2', baseUrl),
    name: 'home_indexnewtwoV2',
    component: () => import(/* webpackChunkName: "home_indexnewtwoV2" */ '@/views/home/indexnewtwoV2/index.vue'),
    meta: {
      title: '我的主页'
    }
  },
  {
    path: getPath('index', baseUrl),
    name: 'home_index',
    component: () => import(/* webpackChunkName: "home_index" */ '@/views/home/index/index.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    // path: getPath('indexV2', baseUrl),
    path: '/homeV2/index',
    name: 'homeV2_index',
    component: () => import(/* webpackChunkName: "home_indexV2" */ '@/views/home/indexV2/indexV2.vue'),
    meta: {
      title: '新版首页'
    }
  },
  {
    path: getPath('CustomConfig', baseUrl),
    name: 'homeV2_CustomConfig',
    component: () => import(/* webpackChunkName: "home_CustomConfig" */ '@/views/home/indexV2/CustomConfig.vue'),
    meta: {
      title: '新版首页自定义配置'
    }
  },
  {
    path: getPath('DubanDetail', baseUrlUpper),
    name: 'Home_DubanDetail',
    component: () => import(/* webpackChunkName: "Home_DubanDetail" */ '@/views/home/dubanDetail/index.vue'),
    meta: {
      title: '明细'
    }
  },
  {
    path: getPath('ProductSupermarket', baseUrl),
    name: 'home_ProductSupermarket',
    component: () => import(/* webpackChunkName: "home_ProductSupermarket" */ '@/views/home/productSupermarket/index.vue'),
    meta: {
      title: '产品超市'
    }
  },
  {
    path: getPath('ProductDetail', baseUrl),
    name: 'home_ProductDetail',
    component: () => import(/* webpackChunkName: "home_ProductDetail" */ '@/views/home/productDetail/index.vue'),
    meta: {
      title: '产品详情'
    }
  },
  {
    path: getPath('PayPage', baseUrl),
    name: 'home_PayPage',
    component: () => import(/* webpackChunkName: "home_PayPage" */ '@/views/home/payPage/index.vue'),
    meta: {
      title: '在线支付'
    }
  },
  {
    path: getPath('index4', baseUrl),
    name: 'home_index4',
    component: () => import(/* webpackChunkName: "home_index4" */ '@/views/home/index4/index.vue'),
    meta: {
      title: '我的主页'
    }
  },
  {
    path: getPath('jingboHome', baseUrl),
    name: 'home_jingboHome',
    component: () => import(/* webpackChunkName: "jingboHome" */ '@/views/home/jingboHome/index.vue'),
    meta: {
      title: '我的主页'
    }
  },
  {
    path: '/overviewList/index',
    name: 'overviewList_jingbo',
    component: () => import(/* webpackChunkName: "/overviewList/index" */ '@/views/overViewList/index.vue'),
    meta: {
      title: '京博概览'
    }
  },
  // {
  //   path: '/agentEvaluation',
  //   name: 'agent_evaluation',
  //   component: () => import(/* webpackChunkName: "/agentEvaluation" */ '@/views/agentEvaluation/index.vue'),
  //   meta: {
  //     title: '代理商评价'
  //   }
  // },
]
